'use strict'

import { useI18n } from 'vue-i18n'

interface FieldItem {
  choiceValue?: unknown
  choices?: Record<string, unknown>
  value?: unknown
}

interface FieldKeyOptions {
  prefix?: string
  suffix?: string
}

export function buildFieldKey(field: string, domain: string | null = null, options?: FieldKeyOptions): string {
  const { prefix, suffix } = options || {}

  if (domain == null) {
    const segments: string[] = field.split('.')
    domain = segments.shift() || ''
    field = segments.join('.')
  }

  const parts: string[] = [domain, 'fields', field]
  if (prefix) {
    parts.push(prefix)
  }
  if (suffix) {
    parts.push(suffix)
  }

  return parts.join('.')
}

export function getBoolLabel(bool: boolean): string {
  const { t } = useI18n()
  return bool ? t('main.bool.yes') : t('main.bool.no')
}

export function getFieldValueByKey(obj: Record<string, FieldItem> | unknown, key: string): unknown {
  if (obj && typeof obj === 'object' && key in obj) {
    const item = (obj as Record<string, FieldItem>)[key]
    if (!item) {
      return ''
    }
    if (item.choiceValue !== undefined) {
      return item.choiceValue
    }
    if (item.choices) {
      for (const [index, choice] of Object.entries(item.choices)) {
        if (index == item.value) {
          return choice
        }
      }
    }
    if (item.value !== undefined) {
      return item.value
    }
  }

  return ''
}
